import { render, staticRenderFns } from "./MenuOptions.vue?vue&type=template&id=1ee605c4&"
import script from "./MenuOptions.vue?vue&type=script&lang=js&"
export * from "./MenuOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports